<template>
     <b-list-group-item size="sm" :to="{name: routeTo}" class="d-flex justify-content-between align-items-center text-white" @click="$emit('change-menu')">
        <div>
            <h5> 
                <b-icon :icon="sidebarIcon" ></b-icon>
                {{sidebarName}}
            </h5>
        </div>
        <b-icon icon="caret-right-fill" v-if="recursive"></b-icon>
    </b-list-group-item>
</template>

<script>
export default {
    name: "sidebarItem",
    props: {
        sidebarName: {
            type: String
        },
        routeTo: {
            type: String
        },
        sidebarIcon: {
            type: String
        },
        recursive: {
            type: Boolean
        }
    }
};

</script>
